// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pz-9";
export var arrowButtonContainer = "_pz-5";
export var arrowButtonIcon = "_pz-6";
export var carouselArrowButton = "_pz-2";
export var carouselElementContainer = "_pz-1";
export var currentSlide = "_pz-8";
export var left = "_pz-3";
export var otherSlide = "_pz-a";
export var productCarouselContainer = "_pz-0";
export var right = "_pz-4";
export var sliderOverflow = "_pz-7";